import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { css } from '@emotion/react';
import { Colors } from '../../../theme/Colors';
import { Typography } from '../../../theme/Typography';
import { Heading, HeadingLevel } from '../../display/Heading';
import { Button } from '../../navigation/Button/Button';
import { BrandButton } from '../../navigation/BrandButton';
import { DarkBackgroundButton } from '../../navigation/DarkBackgroundButton';
import { TextColorMap } from './constants';
import { getCtaBtnColor } from './utils';
const Styles = labelStyles('CTATextContent', {
    root: (alignment = 'left') => css `
    text-align: ${alignment};
    @media screen and (min-width: 768px) {
      max-width: ${alignment === 'center' ? '100%' : '450px'};
    }
  `,
    heading: (alignment, textColor) => css `
    ${Typography.pageHeader4}
    color: ${Colors[textColor]};
    @media screen and (min-width: 768px) {
      ${Typography.pageHeader3}
    }
    margin-bottom: ${alignment === 'center' ? '10px' : '20px'};
  `,
    subHeading: (textColor) => css `
    ${Typography.pageHeader9}
    color: ${Colors[textColor]};
    margin-bottom: 20px;
  `,
    description: (alignment, textColor) => css `
    ${Typography.paragraph1ShortBold}
    color: ${Colors[textColor]};
    margin-bottom: ${alignment === 'center' ? '30px' : '20px'};
  `,
    ctaContainer: css `
    & > a,
    & > button {
      width: 100%;
    }

    @media screen and (min-width: 768px) {
      & > a,
      & > button {
        width: auto;
      }
    }
  `,
});
const getTextColor = (bgColor) => {
    return TextColorMap[bgColor];
};
const getButton = (props) => {
    const btnProps = {
        children: props.ctaText,
        href: props.ctaHref,
        onClick: props.onCtaClick,
        onKeyDown: props.onCtaKeyDown,
        target: props.ctaTarget,
        'data-testid': 'cta-button',
    };
    const btnColor = getCtaBtnColor(props.bgColor, props.ctaBtnColor);
    if (btnColor === 'primary-dark')
        return isolateComponent(DarkBackgroundButton, Object.assign({}, btnProps));
    else if (btnColor === 'brand')
        return isolateComponent(BrandButton, Object.assign({}, btnProps));
    else {
        return isolateComponent(Button, Object.assign({}, btnProps, { color: btnColor, size: "small" }));
    }
};
export const CTATextContent = (props) => {
    const textColor = getTextColor(props.bgColor);
    return (isolateComponent("div", { css: Styles.root(props.alignment) },
        isolateComponent(HeadingLevel, null,
            isolateComponent(Heading, { css: Styles.heading(props.alignment, textColor) }, props.heading),
            props.subHeading && (isolateComponent(HeadingLevel, null,
                isolateComponent(Heading, { css: Styles.subHeading(textColor) }, props.subHeading)))),
        props.description && (isolateComponent("div", { css: Styles.description(props.alignment, textColor) }, props.description)),
        props.ctaText && (props.ctaHref || props.onCtaClick) && (isolateComponent("div", { css: Styles.ctaContainer }, getButton(props)))));
};
//# sourceMappingURL=CTATextContent.js.map
// @zapier/design-system@6.14.1 (10126c41d)
